import Vue from 'vue'

// User settings
export const setSetting = (state, object) => {
  const settings = Object.assign({}, state.settings, object)
  localStorage.setItem('settings', JSON.stringify(settings))
  state.settings = settings
}

// Connectivity
export const setOnline = (state, bool) => { state.online = bool }

// Geolocation
export const setGeoActive = (state, bool) => { state.geoActive = bool }
export const setGeoLoading = (state, bool) => { state.geoLoading = bool }
export const setGeoErr = (state, string) => { state.geoErr = string }
export const setGeoLocation = (state, object) => {
  localStorage.setItem('geo', JSON.stringify(object))
  state.geoLocation = object
  if (state.settings.follow && object.latitude && object.longitude) {
    setSetting(state, { center: [object.latitude, object.longitude] })
  }
}
export const setFlyTo = (state, aLatLon) => {
  state.flyTo = aLatLon
}

// Langs
export const setLang = (state, string) => {
  state.lang = string
  localStorage.setItem('lang', string)
}
export const setLangs = (state, array) => {
  state.langs = array
  localStorage.setItem('langs', JSON.stringify(array))
}

export const setMarkers = (state, array) => {
  for (const m of array) {
    if (!state.markers[m._id]) Vue.set(state.markers, m._id, m)
  }
}
export const setMarkersLoading = (state, bool) => { state.markersLoading = bool }
export const setSwiper = (state, array) => { state.swiper = array }
export const setHighlight = (state, marker) => {
  state.highlight = marker
  if (marker) localStorage.setItem('highlight', JSON.stringify(marker))
  else localStorage.removeItem('highlight')
}
export const setRouteMarker = (state, marker) => {
  state.routeMarker = marker
  localStorage.setItem('route', JSON.stringify(marker))
}
export const setRoutePath = (state, object) => {
  state.routePath = object
  localStorage.setItem('path', JSON.stringify(object))
}
// export const setRoutePolyline = (state, array) => {
//   state.routePolyline = array
//   localStorage.setItem('line', JSON.stringify(array))
// }
// export const setRouteInstructions = (state, array) => {
//   state.routeInstructions = array
//   localStorage.setItem('instructions', JSON.stringify(array))
// }
